import { render, staticRenderFns } from "./SplashPage.vue?vue&type=template&id=47123c57&scoped=true&"
import script from "./SplashPage.vue?vue&type=script&lang=js&"
export * from "./SplashPage.vue?vue&type=script&lang=js&"
import style0 from "./SplashPage.vue?vue&type=style&index=0&id=47123c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47123c57",
  null
  
)

export default component.exports